// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3U24j","search":"Settings_search__3e588","filter":"Settings_filter__1LsZt"};